module.exports = {
  "interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "assigneeType": {
        "type": "string",
        "isOptional": true
      },
      "goalType": {
        "type": "string",
        "isOptional": true
      },
      "interactionType": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "goals-reporting-lib",
    "version": "1"
  }
};